import React from 'react';
import { Helmet } from 'react-helmet';

import { getHref } from 'core/universalRouter/Link';

import { LANGUAGE_CODE } from 'constants/common';
import { useAppSelector } from 'store/hooks';

import { getBaseUrl, getHost, getProtocol } from 'store/__router/selectors';

import type { SeoData } from 'store/seo/types';

const SEO = (props: SeoData) => {
  const host = useAppSelector(getHost);
  const baseUrl = useAppSelector(getBaseUrl);
  const protocol = useAppSelector(getProtocol);
  const {
    title,
    description,
    imageUrl,
    isIndexablePage = false,
    canonicalPath,
    isDynamicUrl = false,
    isTwitterTags = false,
    isDefaultTags = false,
    siteName,
    pageTitle,
    isDescription = false,
    type = 'profile',
    ogUrl,
  } = props;
  const url = getHref(host + baseUrl, canonicalPath, protocol);

  const generateTwitterTags = () => [
    { name: 'twitter:card', content: 'summary' },
    { name: 'twitter:title', content: title },
    { name: 'twitter:description', content: description },
    { name: 'twitter:image', content: imageUrl },
  ];

  const generateDefaultMetaTags = () => [
    { property: 'og:description', content: description },
    { property: 'og:type', content: type },
    { property: 'og:title', content: title },
    { property: 'og:image', content: imageUrl },
    { property: 'og:site_name', content: siteName },
    { property: 'og:url', content: ogUrl || url },
  ];

  const generateDynamicMetaTags = () => {
    const tags: { property?: string; name?: string; content: string }[] = [];

    return tags;
  };

  const generateRobotsTag = () => ({
    name: 'robots',
    content: 'noindex, nofollow, noarchive',
  });

  const metaContents = [
    ...(isTwitterTags ? generateTwitterTags() : []),
    ...(isDefaultTags ? generateDefaultMetaTags() : []),
    ...(!isDynamicUrl ? generateDynamicMetaTags() : []),
    ...(isIndexablePage ? [] : [generateRobotsTag()]),
    ...(isDescription ? [{ name: 'description', content: description }] : []),
  ];
  const linkContents = canonicalPath ? [{ rel: 'canonical', href: url }] : [];

  return (
    <Helmet
      htmlAttributes={{ lang: LANGUAGE_CODE, amp: undefined }}
      title={pageTitle}
      meta={metaContents}
      link={linkContents}
    />
  );
};

export default SEO;
